// Rich-text content edited in the Shopify admin (collection.description,
// astr.seo_extra_content) sometimes gets pasted with headings/paragraphs as
// direct children of a <ul> instead of wrapped in <li>, which breaks the list
// semantics screen readers rely on for item counts ("item 2 of 5"). Restore
// valid semantics on any such stray children without touching the visible markup.
const fixMalformedListSemantics = () => {
  document.querySelectorAll('.collection-seo__description ul, .collection-seo__description ol, .collection-seo__extra ul, .collection-seo__extra ol').forEach((list) => {
    Array.from(list.children).forEach((child) => {
      if (child.tagName === 'LI') {
        return;
      }

      const isDecorative = child.tagName === 'HR' || child.getAttribute('aria-hidden') === 'true';
      child.setAttribute('role', isDecorative ? 'presentation' : 'listitem');
    });
  });
};

export default () => {
  fixMalformedListSemantics();

  if (!document.querySelector('[data-extra-seo]')) {
    return;
  }

  const toggleSeo = () => {
    document.querySelectorAll('[data-show-hide-seo]').forEach((element) => {
      element.classList.toggle('active');
    });

    document.querySelectorAll('[data-extra-seo]').forEach((element) => {
      element.classList.toggle('active');
    });
  };

  document.querySelectorAll('[data-show-hide-seo]').forEach((element) => {
    element.addEventListener('click', toggleSeo);
    element.addEventListener('touchend', toggleSeo);
  });
};
